import { mount, unmount } from 'svelte';

let _modal = null, _modalEl = null;
let _dropdown = null;

export class Hydrant {
  constructor() {
    this.cart();
    this.user();
  }

  cart(data) { hydrateCart(data); }
  user(userId) { hydrateUser(userId); }
}

export const hydrateCart = (cartData) => {
  const localePrefix = window.location.pathname.match(/^\/(?<locale>[a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/)?.groups?.locale || '';
  const cartStorageNamespace = `cart:${window.location.host}:${localePrefix || 'default'}`;
  const cartStorageKey = `${cartStorageNamespace}:state`;

  if (!cartData) {
    try {
      cartData = JSON.parse(localStorage.getItem(cartStorageKey)) || null;
    } catch(e) {
      cartData = null;
    }

    if (!cartData && !localePrefix) {
      try {
        cartData = JSON.parse(localStorage.getItem('cart')) || null;
      } catch(e) {
        cartData = null;
      }
    }
  }

  if (cartData) {
    const count = parseFloat(cartData.items_number).toFixed();
    document.querySelectorAll('[data-ui="cart_count"], .hyd_cart-items-number').forEach(el => {
      if (el.textContent !== count) el.textContent = count;
    });
  }

  // TODO 0,00 zł fallback should be localized
  const total = cartData?.total_price_with_currency ?? '0,00 zł';
  document.querySelectorAll('[data-ui="cart_total"], .hyd_cart-full-price').forEach(el => {
    if (el.textContent !== total) el.textContent = total;
  });
};

export const hydrateUser = (userId) => {
  if (userId === undefined) {
    userId = document.querySelector('meta[name="data-uid"]')?.content || null;
  }

  const btn = document.querySelector('[data-ui="user-button"]');
  if (!btn) return;

  const mobileBtn = document.querySelector('[data-ui="mobile-user-button"]');
  if (mobileBtn && userId) {
    const accountUrl = document.querySelector('meta[name="auth-account-url"]')?.content || '/account';
    mobileBtn.href = accountUrl;
    const mobileLabel = mobileBtn.querySelector('[data-ui="mobile-user-label"]');
    if (mobileLabel && mobileLabel.textContent !== 'Konto') mobileLabel.textContent = 'Konto';
  }

  if (btn._hydHandler) btn.removeEventListener('click', btn._hydHandler);

  if (userId) {
    btn._hydHandler = (e) => {
      e.preventDefault();
      if (_dropdown) {
        unmount(_dropdown);
        _dropdown = null;
        return;
      }
      const accountUrl = document.querySelector('meta[name="auth-account-url"]')?.content || '/account';
      const panelUrl  = document.querySelector('meta[name="auth-panel-url"]')?.content || '';
      import('./UserDropdown.svelte').then(({ default: C }) => {
        _dropdown = mount(C, {
          target: document.body,
          props: {
            anchor: btn,
            accountUrl,
            panelUrl,
            onclose: () => { unmount(_dropdown); _dropdown = null; },
          },
        });
      });
    };
  } else {
    btn._hydHandler = (e) => {
      e.preventDefault();
      if (_modal) return;
      import('./LoginModal.svelte').then(({ default: C }) => {
        _modalEl = document.createElement('div');
        document.body.appendChild(_modalEl);
        _modal = mount(C, {
          target: _modalEl,
          props: {
            onclose: closeModal,
            onsuccess: () => { closeModal(); location.reload(); },
          },
        });
      });
    };
  }

  btn.addEventListener('click', btn._hydHandler);
};

function closeModal() {
  if (_modal) { unmount(_modal); _modal = null; }
  _modalEl?.remove();
  _modalEl = null;
}

export default Hydrant;
